module.exports = __webpack_public_path__ + "img/PASTE.b3056aaf.svg";